import { render, staticRenderFns } from "./DrawerPop.vue?vue&type=template&id=20005af2&scoped=true"
import script from "./DrawerPop.vue?vue&type=script&lang=js"
export * from "./DrawerPop.vue?vue&type=script&lang=js"
import style0 from "./DrawerPop.vue?vue&type=style&index=0&id=20005af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20005af2",
  null
  
)

export default component.exports